import React, { useCallback } from 'react';

import { Link } from '../';
import { changeZindex } from './lightHouse';

type Props = {
  children: React.ReactNode;
  page?: 'article' | 'category' | 'contact' | 'home' | 'suggestions';
  id?: string;
};

const HelpDocLink = ({ children, page = 'article', id }: Props) => {
  const onClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      if (window.Lighthouse) {
        changeZindex('2147483647');
        window.Lighthouse.navigate(page, id);
      }
    },
    [page, id],
  );

  return (
    <Link onClick={onClick}>
      {children}
    </Link>
  );
};

export default HelpDocLink;
